/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "RxDB",
  "tagline": "Realtime JavaScript Database",
  "favicon": "/files/logo/logo.svg",
  "headTags": [
    {
      "tagName": "script",
      "attributes": {
        "type": "text/javascript"
      },
      "innerHTML": "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('consent', 'default', { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'denied', wait_for_update: 500, region: [\"AT\",\"BE\",\"BG\",\"HR\",\"CY\",\"CZ\",\"DK\",\"EE\",\"FI\",\"FR\",\"DE\",\"GR\",\"HU\",\"IE\",\"IT\",\"LV\",\"LT\",\"LU\",\"MT\",\"NL\",\"PL\",\"PT\",\"RO\",\"SK\",\"SI\",\"ES\",\"SE\",\"IS\",\"LI\",\"NO\",\"GB\"] }); gtag('set', 'ads_data_redaction', true); gtag('js', new Date()); gtag('config', 'G-62D63SY3S0', { send_page_view: false });"
    },
    {
      "tagName": "meta",
      "attributes": {
        "name": "theme-color",
        "content": "#ed168f"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "icon",
        "type": "image/x-icon",
        "href": "/files/logo/icon.ico"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "apple-touch-icon",
        "href": "/img/apple-touch-icon.png",
        "sizes": "180x180"
      }
    },
    {
      "tagName": "link",
      "attributes": {
        "rel": "preconnect",
        "href": "https://region1.analytics.google.com/"
      }
    },
    {
      "tagName": "script",
      "attributes": {
        "type": "application/ld+json"
      },
      "innerHTML": "{\"@context\":\"https://schema.org\",\"@type\":\"SoftwareApplication\",\"name\":\"RxDB\",\"applicationCategory\":\"DeveloperApplication\",\"operatingSystem\":\"Any\",\"description\":\"A fast, local-first, reactive NoSQL database for JavaScript applications. Supports offline-first sync, real-time replication, and works across browsers, Node.js, Electron, React Native, and Flutter.\",\"url\":\"https://rxdb.info\",\"softwareVersion\":\"17.6.0\",\"license\":\"https://github.com/pubkey/rxdb/blob/master/LICENSE.txt\",\"downloadUrl\":\"https://www.npmjs.com/package/rxdb\",\"softwareHelp\":{\"@type\":\"CreativeWork\",\"url\":\"https://rxdb.info/quickstart.html\"},\"offers\":{\"@type\":\"Offer\",\"price\":\"0\",\"priceCurrency\":\"USD\"},\"author\":{\"@type\":\"Organization\",\"name\":\"RxDB\",\"url\":\"https://rxdb.info\",\"logo\":\"https://rxdb.info/files/logo/logo.svg\",\"sameAs\":[\"https://github.com/pubkey/rxdb\",\"https://twitter.com/rxdbjs\",\"https://www.linkedin.com/company/rxdb\"]}}"
    },
    {
      "tagName": "script",
      "attributes": {
        "type": "application/ld+json"
      },
      "innerHTML": "{\"@context\":\"https://schema.org\",\"@graph\":[{\"@type\":\"Organization\",\"@id\":\"https://rxdb.info/#organization\",\"name\":\"RxDB\",\"url\":\"https://rxdb.info\",\"logo\":\"https://rxdb.info/files/logo/logo.svg\",\"foundingDate\":\"2016\",\"founder\":{\"@type\":\"Person\",\"name\":\"Daniel Meyer\",\"url\":\"https://github.com/pubkey\"},\"sameAs\":[\"https://github.com/pubkey/rxdb\",\"https://twitter.com/rxdbjs\",\"https://www.linkedin.com/company/rxdb\",\"https://www.npmjs.com/package/rxdb\"]},{\"@type\":\"WebSite\",\"@id\":\"https://rxdb.info/#website\",\"name\":\"RxDB\",\"url\":\"https://rxdb.info\",\"inLanguage\":\"en\",\"publisher\":{\"@id\":\"https://rxdb.info/#organization\"}}]}"
    }
  ],
  "url": "https://rxdb.info",
  "baseUrl": "/",
  "organizationName": "pubkey",
  "projectName": "rxdb",
  "future": {
    "experimental_faster": {
      "swcJsLoader": true,
      "swcJsMinimizer": true,
      "swcHtmlMinimizer": true,
      "lightningCssMinimizer": true,
      "mdxCrossCompilerCache": true,
      "rspackBundler": true,
      "rspackPersistentCache": true,
      "ssgWorkerThreads": true
    },
    "v4": {
      "removeLegacyPostBuildHeadAttribute": true,
      "useCssCascadeLayers": false
    },
    "experimental_storage": {
      "type": "localStorage",
      "namespace": false
    },
    "experimental_router": "browser"
  },
  "onBrokenLinks": "throw",
  "markdown": {
    "hooks": {
      "onBrokenMarkdownLinks": "throw",
      "onBrokenMarkdownImages": "throw"
    },
    "format": "mdx",
    "mermaid": false,
    "emoji": true,
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    }
  },
  "i18n": {
    "defaultLocale": "en",
    "locales": [
      "en"
    ],
    "path": "i18n",
    "localeConfigs": {}
  },
  "plugins": [
    [
      "docusaurus-plugin-llms",
      {
        "generateLLMsTxt": true,
        "generateLLMsFullTxt": true,
        "docsDir": "docs",
        "ignoreFiles": [
          "docs/adapters.md",
          "docs/rx-storage-lokijs.md"
        ],
        "title": "RxDB Documentation",
        "description": "Authoritative reference documentation for RxDB, a reactive, local-first NoSQL database for JavaScript with offline support and explicit replication.",
        "rootContent": "RxDB (Reactive Database) is a local-first, NoSQL database for JavaScript applications.\nIt stores data on the client (browser, Node.js, React Native, Electron, Capacitor) and optionally replicates with a backend server.\nData is modeled as JSON documents inside collections, validated by JSON Schema, and queried with the Mango/MongoDB query syntax.\nAll data access is reactive through RxJS Observables so that UI components update automatically when data changes.\n\nSource code: https://github.com/pubkey/rxdb\nWebsite: https://rxdb.info\nCommunity and support: For help beyond these docs, the RxDB Discord is the fastest place to reach maintainers: https://rxdb.info/chat/\n\nTopic-specific documentation files:\n- [Core API](https://rxdb.info/llms-api.txt): RxDatabase, RxSchema, RxCollection, RxDocument, RxQuery\n- [Storages](https://rxdb.info/llms-storages.txt): RxStorage layer, all storage backends and wrappers\n- [Replication](https://rxdb.info/llms-replication.txt): Sync engine, HTTP, GraphQL, WebSocket, CouchDB, Firestore, Supabase, WebRTC P2P",
        "excludeImports": false,
        "removeDuplicateHeadings": true,
        "generateMarkdownFiles": true,
        "includeOrder": [
          "overview.md",
          "quickstart.md",
          "install.md",
          "dev-mode.md",
          "docs/tutorials/typescript.md",
          "rx-database.md",
          "rx-schema.md",
          "rx-collection.md",
          "rx-document.md",
          "rx-query.md",
          "rx-storage.md",
          "rx-storage-localstorage.md",
          "rx-storage-indexeddb.md",
          "rx-storage-opfs.md",
          "rx-storage-memory.md",
          "rx-storage-filesystem-node.md",
          "rx-storage-filesystem-expo.md",
          "rx-storage-sqlite.md",
          "rx-storage-dexie.md",
          "rx-storage-mongodb.md",
          "rx-storage-denokv.md",
          "rx-storage-foundationdb.md",
          "schema-validation.md",
          "encryption.md",
          "key-compression.md",
          "logger.md",
          "rx-storage-remote.md",
          "rx-storage-worker.md",
          "rx-storage-shared-worker.md",
          "rx-storage-memory-mapped.md",
          "rx-storage-memory-synced.md",
          "rx-storage-sharding.md",
          "rx-storage-localstorage-meta-optimizer.md",
          "electron.md",
          "replication.md",
          "replication-http.md",
          "replication-server.md",
          "replication-graphql.md",
          "replication-websocket.md",
          "replication-couchdb.md",
          "replication-webrtc.md",
          "replication-firestore.md",
          "replication-mongodb.md",
          "replication-supabase.md",
          "replication-google-drive.md",
          "replication-microsoft-onedrive.md",
          "replication-nats.md",
          "replication-appwrite.md",
          "rx-server.md",
          "rx-server-scaling.md",
          "transactions-conflicts-revisions.md",
          "query-cache.md",
          "plugins.md",
          "errors.md",
          "testing.md",
          "migration-schema.md",
          "migration-storage.md",
          "rx-attachment.md",
          "rx-pipeline.md",
          "reactivity.md",
          "rx-state.md",
          "rx-local-document.md",
          "cleanup.md",
          "backup.md",
          "leader-election.md",
          "middleware.md",
          "crdt.md",
          "population.md",
          "orm.md",
          "fulltext-search.md",
          "query-optimizer.md",
          "webmcp.md",
          "dbviewer.md",
          "third-party-plugins.md",
          "rx-storage-performance.md",
          "nosql-performance-tips.md",
          "slow-indexeddb.md"
        ],
        "includeUnmatchedLast": true,
        "pathTransformation": {
          "ignorePaths": [
            "docs"
          ]
        },
        "customLLMFiles": [
          {
            "filename": "llms-api.txt",
            "includePatterns": [
              "overview.md",
              "quickstart.md",
              "install.md",
              "rx-database.md",
              "rx-schema.md",
              "rx-collection.md",
              "rx-document.md",
              "rx-query.md",
              "rx-attachment.md",
              "rx-local-document.md",
              "rx-state.md",
              "rx-pipeline.md",
              "rx-storage.md",
              "docs/tutorials/typescript.md"
            ],
            "fullContent": true,
            "title": "RxDB Core API Documentation",
            "description": "Reference for the core RxDB API: RxDatabase, RxSchema, RxCollection, RxDocument, RxQuery, and related entities."
          },
          {
            "filename": "llms-storages.txt",
            "includePatterns": [
              "rx-storage.md",
              "rx-storage-*.md",
              "schema-validation.md",
              "encryption.md",
              "key-compression.md",
              "logger.md",
              "electron.md"
            ],
            "fullContent": true,
            "title": "RxDB Storage Documentation",
            "description": "Complete reference for the RxDB RxStorage layer, all storage backends (LocalStorage, IndexedDB, OPFS, SQLite, Memory, Dexie.js, MongoDB, FoundationDB, DenoKV) and storage wrappers (encryption, compression, sharding, workers)."
          },
          {
            "filename": "llms-replication.txt",
            "includePatterns": [
              "replication.md",
              "replication-*.md"
            ],
            "fullContent": true,
            "title": "RxDB Replication Documentation",
            "description": "Complete reference for RxDB replication and data sync: HTTP, GraphQL, WebSocket, CouchDB, Firestore, Supabase, WebRTC P2P, and more."
          }
        ]
      }
    ],
    null
  ],
  "scripts": [],
  "presets": [
    [
      "classic",
      {
        "googleTagManager": {
          "containerId": "GTM-PL63TR5"
        },
        "sitemap": {
          "lastmod": "date",
          "changefreq": "weekly",
          "priority": 0.5,
          "filename": "sitemap.xml"
        },
        "docs": {
          "sidebarPath": "./sidebars.js",
          "routeBasePath": "",
          "path": "./docs",
          "showLastUpdateTime": true,
          "breadcrumbs": false,
          "remarkPlugins": [
            null
          ],
          "beforeDefaultRehypePlugins": [
            [
              null,
              {
                "theme": {
                  "name": "css-variables",
                  "type": "dark",
                  "colors": {
                    "editor.foreground": "var(--shiki-foreground)",
                    "editor.background": "var(--shiki-background)",
                    "terminal.ansiBlack": "var(--shiki-ansi-black)",
                    "terminal.ansiRed": "var(--shiki-ansi-red)",
                    "terminal.ansiGreen": "var(--shiki-ansi-green)",
                    "terminal.ansiYellow": "var(--shiki-ansi-yellow)",
                    "terminal.ansiBlue": "var(--shiki-ansi-blue)",
                    "terminal.ansiMagenta": "var(--shiki-ansi-magenta)",
                    "terminal.ansiCyan": "var(--shiki-ansi-cyan)",
                    "terminal.ansiWhite": "var(--shiki-ansi-white)",
                    "terminal.ansiBrightBlack": "var(--shiki-ansi-bright-black)",
                    "terminal.ansiBrightRed": "var(--shiki-ansi-bright-red)",
                    "terminal.ansiBrightGreen": "var(--shiki-ansi-bright-green)",
                    "terminal.ansiBrightYellow": "var(--shiki-ansi-bright-yellow)",
                    "terminal.ansiBrightBlue": "var(--shiki-ansi-bright-blue)",
                    "terminal.ansiBrightMagenta": "var(--shiki-ansi-bright-magenta)",
                    "terminal.ansiBrightCyan": "var(--shiki-ansi-bright-cyan)",
                    "terminal.ansiBrightWhite": "var(--shiki-ansi-bright-white)"
                  },
                  "tokenColors": [
                    {
                      "scope": [
                        "keyword.operator.accessor",
                        "meta.group.braces.round.function.arguments",
                        "meta.template.expression",
                        "markup.fenced_code meta.embedded.block"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-foreground)"
                      }
                    },
                    {
                      "scope": "emphasis",
                      "settings": {
                        "fontStyle": "italic"
                      }
                    },
                    {
                      "scope": [
                        "strong",
                        "markup.heading.markdown",
                        "markup.bold.markdown"
                      ],
                      "settings": {
                        "fontStyle": "bold"
                      }
                    },
                    {
                      "scope": [
                        "markup.italic.markdown"
                      ],
                      "settings": {
                        "fontStyle": "italic"
                      }
                    },
                    {
                      "scope": "meta.link.inline.markdown",
                      "settings": {
                        "fontStyle": "underline",
                        "foreground": "var(--shiki-token-link)"
                      }
                    },
                    {
                      "scope": [
                        "string",
                        "markup.fenced_code",
                        "markup.inline"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-string)"
                      }
                    },
                    {
                      "scope": [
                        "comment",
                        "string.quoted.docstring.multi"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-comment)"
                      }
                    },
                    {
                      "scope": [
                        "constant.numeric",
                        "constant.language",
                        "constant.other.placeholder",
                        "constant.character.format.placeholder",
                        "variable.language.this",
                        "variable.other.object",
                        "variable.other.class",
                        "variable.other.constant",
                        "meta.property-name",
                        "meta.property-value",
                        "support"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-constant)"
                      }
                    },
                    {
                      "scope": [
                        "keyword",
                        "storage.modifier",
                        "storage.type",
                        "storage.control.clojure",
                        "entity.name.function.clojure",
                        "entity.name.tag.yaml",
                        "support.function.node",
                        "support.type.property-name.json",
                        "punctuation.separator.key-value",
                        "punctuation.definition.template-expression"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-keyword)"
                      }
                    },
                    {
                      "scope": "variable.parameter.function",
                      "settings": {
                        "foreground": "var(--shiki-token-parameter)"
                      }
                    },
                    {
                      "scope": [
                        "support.function",
                        "entity.name.type",
                        "entity.other.inherited-class",
                        "meta.function-call",
                        "meta.instance.constructor",
                        "entity.other.attribute-name",
                        "entity.name.function",
                        "constant.keyword.clojure"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-function)"
                      }
                    },
                    {
                      "scope": [
                        "entity.name.tag",
                        "string.quoted",
                        "string.regexp",
                        "string.interpolated",
                        "string.template",
                        "string.unquoted.plain.out.yaml",
                        "keyword.other.template"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-string-expression)"
                      }
                    },
                    {
                      "scope": [
                        "punctuation.definition.arguments",
                        "punctuation.definition.dict",
                        "punctuation.separator",
                        "meta.function-call.arguments"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-punctuation)"
                      }
                    },
                    {
                      "scope": [
                        "markup.underline.link",
                        "punctuation.definition.metadata.markdown"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-link)"
                      }
                    },
                    {
                      "scope": [
                        "beginning.punctuation.definition.list.markdown"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-string)"
                      }
                    },
                    {
                      "scope": [
                        "punctuation.definition.string.begin.markdown",
                        "punctuation.definition.string.end.markdown",
                        "string.other.link.title.markdown",
                        "string.other.link.description.markdown"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-keyword)"
                      }
                    },
                    {
                      "scope": [
                        "markup.inserted",
                        "meta.diff.header.to-file",
                        "punctuation.definition.inserted"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-inserted)"
                      }
                    },
                    {
                      "scope": [
                        "markup.deleted",
                        "meta.diff.header.from-file",
                        "punctuation.definition.deleted"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-deleted)"
                      }
                    },
                    {
                      "scope": [
                        "markup.changed",
                        "punctuation.definition.changed"
                      ],
                      "settings": {
                        "foreground": "var(--shiki-token-changed)"
                      }
                    }
                  ]
                },
                "bypassInlineCode": true
              }
            ]
          ]
        },
        "theme": {
          "customCss": "./src/css/custom.css"
        }
      }
    ]
  ],
  "themeConfig": {
    "image": "img/rxdb_social_card.png",
    "metadata": [
      {
        "name": "keywords",
        "content": "RxDB, JavaScript database, local-first, offline-first, reactive database, NoSQL, real-time sync, browser database, IndexedDB, TypeScript"
      },
      {
        "property": "og:type",
        "content": "website"
      },
      {
        "name": "twitter:site",
        "content": "@rxdbjs"
      }
    ],
    "colorMode": {
      "defaultMode": "dark",
      "disableSwitch": true,
      "respectPrefersColorScheme": false
    },
    "navbar": {
      "title": "",
      "logo": {
        "alt": "RxDB",
        "src": "files/logo/logo_text_white.svg",
        "width": 107,
        "height": 38
      },
      "items": [
        {
          "href": "/overview.html",
          "label": "Docs",
          "position": "left"
        },
        {
          "href": "/replication.html",
          "label": "Sync",
          "position": "left",
          "dropdown": "sync"
        },
        {
          "href": "/rx-storage.html",
          "label": "Storages",
          "position": "left",
          "dropdown": "storages"
        },
        {
          "href": "/premium/",
          "label": "Pricing",
          "position": "left"
        },
        {
          "href": "/consulting/",
          "label": "Support",
          "position": "left"
        },
        {
          "to": "/chat/",
          "target": "_blank",
          "label": " ",
          "aria-label": "Discord",
          "position": "right",
          "className": "navbar-icon navbar__item navbar-icon-discord"
        },
        {
          "to": "/code/",
          "target": "_blank",
          "label": " ",
          "aria-label": "GitHub",
          "position": "right",
          "className": "navbar-icon navbar__item navbar-icon-github"
        }
      ],
      "hideOnScroll": false
    },
    "algolia": {
      "appId": "MFS60LRE5L",
      "apiKey": "22d63ecafdabc681e5c59f767c4ceafa",
      "indexName": "RxDB Docs Crawler",
      "contextualSearch": true,
      "searchParameters": {},
      "searchPagePath": "search"
    },
    "footer": {
      "style": "dark",
      "links": [],
      "copyright": " "
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "prism": {
      "additionalLanguages": [],
      "theme": {
        "plain": {
          "color": "#bfc7d5",
          "backgroundColor": "#292d3e"
        },
        "styles": [
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(105, 112, 152)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "string",
              "inserted"
            ],
            "style": {
              "color": "rgb(195, 232, 141)"
            }
          },
          {
            "types": [
              "number"
            ],
            "style": {
              "color": "rgb(247, 140, 108)"
            }
          },
          {
            "types": [
              "builtin",
              "char",
              "constant",
              "function"
            ],
            "style": {
              "color": "rgb(130, 170, 255)"
            }
          },
          {
            "types": [
              "punctuation",
              "selector"
            ],
            "style": {
              "color": "rgb(199, 146, 234)"
            }
          },
          {
            "types": [
              "variable"
            ],
            "style": {
              "color": "rgb(191, 199, 213)"
            }
          },
          {
            "types": [
              "class-name",
              "attr-name"
            ],
            "style": {
              "color": "rgb(255, 203, 107)"
            }
          },
          {
            "types": [
              "tag",
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 114)"
            }
          },
          {
            "types": [
              "operator"
            ],
            "style": {
              "color": "rgb(137, 221, 255)"
            }
          },
          {
            "types": [
              "boolean"
            ],
            "style": {
              "color": "rgb(255, 88, 116)"
            }
          },
          {
            "types": [
              "keyword"
            ],
            "style": {
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "doctype"
            ],
            "style": {
              "color": "rgb(199, 146, 234)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "color": "rgb(178, 204, 214)"
            }
          },
          {
            "types": [
              "url"
            ],
            "style": {
              "color": "rgb(221, 221, 221)"
            }
          }
        ]
      },
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "baseUrlIssueBanner": true,
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "themes": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false
};
